import authenticatedPopsApi from "../utils/portalApi";
import {
  GET_CLIENT_ELIGIBILITY,
  GET_CLIENT_PROFILE,
  getAccountTransactionsEndpoint,
  getPaymentCardDetailsEndpoint,
} from "./apiRoutes";

export const getClientData = async () =>
  authenticatedPopsApi.get(GET_CLIENT_PROFILE);

export const getClientEligibility = async () =>
  authenticatedPopsApi.get(GET_CLIENT_ELIGIBILITY);

export const getAccountTransactions = async (accountNumber) =>
  authenticatedPopsApi.get(getAccountTransactionsEndpoint(accountNumber));

export const getCardDetails = (accountNumber) => {
  return authenticatedPopsApi.get(getPaymentCardDetailsEndpoint(accountNumber));
}
